// AI Scene Studio edit helpers (display copy of backend/src/lib/full-scene-edit.js; the server validates).
export const FPS = 24
export const FRAME_MS = 1000 / FPS
export const MIN_CLIP_MS = Math.round(FRAME_MS * 6)
export const snap = (ms) => Math.round(Math.round(Number(ms) / FRAME_MS) * FRAME_MS)

export const defaultEdit = (clips) => ({
  order: clips.map((c) => c.clipId),
  trims: clips.map((c) => ({ clipId: c.clipId, inMs: 0, outMs: snap(c.durationMs) })),
  removed: [],
})

export const trimOf = (edit, clip) => edit.trims.find((t) => t.clipId === clip.clipId) || { clipId: clip.clipId, inMs: 0, outMs: snap(clip.durationMs) }

export const setTrim = (edit, clip, inMs, outMs) => {
  const full = snap(clip.durationMs)
  let a = Math.max(0, Math.min(snap(inMs), full - MIN_CLIP_MS))
  let b = Math.min(full, Math.max(snap(outMs), a + MIN_CLIP_MS))
  const trims = edit.trims.some((t) => t.clipId === clip.clipId) ? edit.trims.map((t) => (t.clipId === clip.clipId ? { clipId: t.clipId, inMs: a, outMs: b } : t)) : [...edit.trims, { clipId: clip.clipId, inMs: a, outMs: b }]
  return { ...edit, trims }
}

export const move = (edit, from, to) => {
  if (to < 0 || to >= edit.order.length || from === to) return edit
  const order = edit.order.slice()
  const [id] = order.splice(from, 1)
  order.splice(to, 0, id)
  return { ...edit, order }
}

export const toggleRemoved = (edit, clipId) => ({ ...edit, removed: edit.removed.includes(clipId) ? edit.removed.filter((x) => x !== clipId) : [...edit.removed, clipId] })

export const resetClip = (edit, clip) => setTrim({ ...edit, removed: edit.removed.filter((x) => x !== clip.clipId) }, clip, 0, clip.durationMs)

export const sequence = (clips, edit) => {
  const byId = new Map(clips.map((c) => [c.clipId, c]))
  return edit.order.filter((id) => byId.has(id) && !edit.removed.includes(id)).map((id) => { const c = byId.get(id); const t = trimOf(edit, c); return { clip: c, inMs: t.inMs, outMs: t.outMs } })
}

export const fmt = (ms) => { const s = Math.max(0, ms) / 1000; const m = Math.floor(s / 60); return `${m}:${(s - m * 60).toFixed(2).padStart(5, "0")}` }
